/**
 * OnboardingPage — thin shell that mounts the canonical Profile
 * Questionnaire in CREATE mode.
 *
 * Replaces the prior ad-hoc English sponsor form + friend profile
 * view combination. The new shape:
 *
 *   /onboarding
 *     -> ProfileQuestionnairePage (mode=create)
 *        -> S005 Step3TransitionScreen on completion
 *           -> /discover
 *
 * The obsolete `/paywall` navigation is removed (per §34 of the
 * Bucket-B briefing). The S005 transition is honored.
 *
 * Security:
 * - Public route (per the route registry). No `sponsor_access`
 *   gate.
 * - Identity-minimized data only — see the questionnaire feature
 *   notes.
 */

import { Navigate } from 'react-router-dom';
import { ProfileQuestionnairePage } from './ProfileQuestionnairePage';
import { RoutePaths } from '@/routes';
import { useAuthStore } from '@/store/authStore';

/**
 * Onboarding entry. Defers auth-state decisions to the auth store;
 * the questionnaire itself decides CREATE vs EDIT from the URL
 * `?mode=edit` query param.
 */
export function OnboardingPage() {
  const authStatus = useAuthStore((s) => s.authStatus);

  if (authStatus === 'loading' || authStatus === 'unknown') {
    return (
      <div className="page" data-testid="onboarding-loading">
        <p>Загрузка...</p>
      </div>
    );
  }

  if (authStatus === 'anonymous') {
    return <Navigate to={RoutePaths.LOGIN} replace />;
  }

  return <ProfileQuestionnairePage />;
}